import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["hasCustomEmailCard", "subject", "message", "defaultEmailTemplate", "canCustomiseData", "onResetField"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { NavLink } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import config from 'utils/config';
import FormField from 'components/FormField';
import Stack from 'components/Stack';
import CheckboxOption from 'components/CheckboxOption';
import Hint from 'components/Hint';
import TextLink from 'components/TextLink';
import CustomEmailCard from './CustomEmailCard';
import useUserLocale from 'hooks/useUserLocale';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function CustomEmailField(_ref) {
  var hasCustomEmailCard = _ref.hasCustomEmailCard,
    subject = _ref.subject,
    message = _ref.message,
    defaultEmailTemplate = _ref.defaultEmailTemplate,
    canCustomiseData = _ref.canCustomiseData,
    onResetField = _ref.onResetField,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useUserLocale = useUserLocale(),
    locale = _useUserLocale.locale;
  var userLanguageEnabled = config.userLanguageEnabled;
  var hasPreviousCustomData = !!hasCustomEmailCard.value;
  function onToggleCustomEmailCard() {
    onResetField('subject');
    onResetField('message');
    hasCustomEmailCard.set(!hasCustomEmailCard.value);
  }
  return /*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({
    required: true,
    label: t('property_email'),
    as: "fieldset"
  }, otherProps), {}, {
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: "xs",
      children: [/*#__PURE__*/_jsx(CheckboxOption, {
        label: t('actions_customise_subject_and_message'),
        checked: hasCustomEmailCard.value,
        onChange: onToggleCustomEmailCard,
        disabled: !canCustomiseData
      }), hasCustomEmailCard.value && canCustomiseData && /*#__PURE__*/_jsx(CustomEmailCard, {
        subject: subject,
        message: message,
        defaultEmailTemplate: defaultEmailTemplate,
        onResetField: onResetField
      }), /*#__PURE__*/_jsxs(Hint, {
        children: [/*#__PURE__*/_jsxs(Trans, {
          i18nKey: "content_status_share_panel_hint_email_template",
          emailTemplate: "resetRecommendation",
          children: ["This notification uses the", /*#__PURE__*/_jsx(TextLink, {
            as: NavLink,
            to: "/settings/email-templates/resetRecommendation?template-language=".concat(locale),
            target: "_blank",
            children: t('email_template_reset_recommendation_title')
          }), "email template."]
        }), ' ', !canCustomiseData && hasPreviousCustomData && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("span", {
            children: t('nudge_hint_custom_email_data')
          }), ' ', userLanguageEnabled && /*#__PURE__*/_jsxs(Trans, {
            i18nKey: "nudge_hint_update_custom_email_data",
            children: ["To update the customised subject and message, please", /*#__PURE__*/_jsx(TextLink, {
              href: "#nudge_language_field",
              children: "select a language"
            }), "for this nudge."]
          })]
        }), !canCustomiseData && !hasPreviousCustomData && userLanguageEnabled && /*#__PURE__*/_jsxs(Trans, {
          i18nKey: "nudge_share_panel_hint_select_language",
          children: ["To customise subject and message, please", /*#__PURE__*/_jsx(TextLink, {
            href: "#nudge_language_field",
            children: "select a language"
          }), "for this nudge."]
        })]
      })]
    })
  }));
}
export default CustomEmailField;